import clsx from "clsx";
import React from "react";
import { FC } from "react";
import { PropTypes } from "@material-ui/core";
import { lighten } from "@material-ui/core";
import { Omit } from "@material-ui/types";
import { Theme } from "@material-ui/core/styles";
import { darken } from "@material-ui/core/styles";
import MuiIconButton from "@material-ui/core/IconButton";
import { IconButtonProps as MuiIconButtonProps } from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { COLORS } from "../../constants";

const useStyles = makeStyles((theme: Theme) => ({
  btn: {},
  grey: {
    color: lighten(theme.palette.grey.A400, 0.2),
    backgroundColor: lighten(theme.palette.grey.A100, 0.6),
    "&:hover": {
      backgroundColor: darken(
        theme.palette.grey.A100,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.grey.A100,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:focus": {
      backgroundColor: darken(
        theme.palette.grey.A100,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.grey.A100,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:active": {
      backgroundColor: darken(
        theme.palette.grey.A100,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.grey.A100,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:disabled": {
      pointerEvents: "auto",
      cursor: "pointer",
      color: lighten(theme.palette.grey.A400, 0.3),
      backgroundColor: lighten(theme.palette.grey.A100, 0.7),
      "&:hover": {
        backgroundColor: lighten(theme.palette.grey.A100, 0.6),
      },
    },
  },
  secondary: {
    color: "#ffffff!important",
    backgroundColor: theme.palette.secondary.light,
    "&:hover": {
      backgroundColor: darken(
        theme.palette.secondary.light,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.secondary.light,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:focus": {
      backgroundColor: darken(
        theme.palette.secondary.light,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.secondary.light,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:active": {
      backgroundColor: darken(
        theme.palette.secondary.light,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.secondary.light,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:disabled": {
      pointerEvents: "auto",
      color: "#ffffff!important",
      backgroundColor: lighten(
        theme.palette.secondary.light,
        theme.palette.action.hoverOpacity,
      ),
      cursor: "pointer",
      "&:hover": {
        backgroundColor: lighten(
          theme.palette.secondary.light,
          theme.palette.action.hoverOpacity,
        ),
      },
    },
  },
  secondaryDark: {
    color: "#ffffff!important",
    backgroundColor: theme.palette.secondary.dark,
    "&:hover": {
      backgroundColor: darken(
        theme.palette.secondary.dark,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.secondary.dark,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:focus": {
      backgroundColor: darken(
        theme.palette.secondary.dark,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.secondary.dark,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:active": {
      backgroundColor: darken(
        theme.palette.secondary.dark,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.secondary.dark,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:disabled": {
      pointerEvents: "auto",
      color: "#ffffff!important",
      backgroundColor: lighten(
        theme.palette.secondary.dark,
        theme.palette.action.hoverOpacity,
      ),
      cursor: "pointer",
      "&:hover": {
        backgroundColor: lighten(
          theme.palette.secondary.dark,
          theme.palette.action.hoverOpacity,
        ),
      },
    },
  },
  successDark: {
    color: "#ffffff!important",
    backgroundColor: theme.palette.success.main,
    "&:hover": {
      backgroundColor: darken(
        theme.palette.success.main,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.success.main,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:focus": {
      backgroundColor: darken(
        theme.palette.success.main,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.success.main,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:active": {
      backgroundColor: darken(
        theme.palette.success.main,
        theme.palette.action.hoverOpacity,
      ),
      borderColor: darken(
        theme.palette.success.main,
        theme.palette.action.hoverOpacity,
      ),
    },
    "&:disabled": {
      pointerEvents: "auto",
      color: "#ffffff!important",
      backgroundColor: lighten(
        theme.palette.success.main,
        theme.palette.action.hoverOpacity,
      ),
      cursor: "pointer",
      "&:hover": {
        backgroundColor: lighten(
          theme.palette.success.main,
          theme.palette.action.hoverOpacity,
        ),
      },
    },
  },
  success: {
    color: theme.palette.success.main,
    backgroundColor: lighten(theme.palette.success.main, 0.8),
    "&:hover": {
      backgroundColor: lighten(theme.palette.success.main, 0.7),
      borderColor: lighten(theme.palette.success.main, 0.7),
    },
    "&:focus,&:active": {
      backgroundColor: lighten(theme.palette.success.main, 0.7),
      borderColor: lighten(theme.palette.success.main, 0.7),
    },
    "&:disabled": {
      pointerEvents: "auto",
      cursor: "pointer",
      color: lighten(theme.palette.success.main, 0.8),
      backgroundColor: lighten(theme.palette.success.main, 0.8),
      "&:hover": {
        backgroundColor: lighten(theme.palette.success.main, 0.9),
      },
    },
  },
  info: {
    color: theme.palette.info.main,
    backgroundColor: lighten(theme.palette.info.main, 0.8),
    "&:hover": {
      backgroundColor: lighten(theme.palette.info.main, 0.7),
      borderColor: lighten(theme.palette.info.main, 0.7),
    },
    "&:focus,&:active": {
      backgroundColor: lighten(theme.palette.info.main, 0.7),
      borderColor: lighten(theme.palette.info.main, 0.7),
    },
    "&:disabled": {
      pointerEvents: "auto",
      cursor: "pointer",
      color: lighten(theme.palette.info.main, 0.8),
      backgroundColor: lighten(theme.palette.info.main, 0.8),
      "&:hover": {
        backgroundColor: lighten(theme.palette.info.main, 0.9),
      },
    },
  },
  message: {
    color: COLORS.message.main,
    backgroundColor: lighten(COLORS.message.main, 0.85),
    "&:hover": {
      backgroundColor: lighten(COLORS.message.main, 0.75),
      borderColor: lighten(COLORS.message.main, 0.7),
    },
    "&:focus,&:active": {
      backgroundColor: lighten(COLORS.message.main, 0.7),
      borderColor: lighten(COLORS.message.main, 0.7),
    },
    "&:disabled": {
      pointerEvents: "auto",
      cursor: "pointer",
      color: lighten(COLORS.message.main, 0.8),
      backgroundColor: lighten(COLORS.message.main, 0.8),
      "&:hover": {
        backgroundColor: lighten(COLORS.message.main, 0.9),
      },
    },
  },
  warning: {
    color: theme.palette.warning.main,
    backgroundColor: lighten(theme.palette.warning.main, 0.8),
    "&:hover": {
      backgroundColor: lighten(theme.palette.warning.main, 0.7),
      borderColor: lighten(theme.palette.warning.main, 0.7),
    },
    "&:focus,&:active": {
      backgroundColor: lighten(theme.palette.warning.main, 0.7),
      borderColor: lighten(theme.palette.warning.main, 0.7),
    },
    "&:disabled": {
      pointerEvents: "auto",
      color: lighten(theme.palette.primary.main, 0.8),
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
  },
  error: {
    color: theme.palette.error.main,
    backgroundColor: lighten(theme.palette.error.main, 0.9),
    "&:hover": {
      backgroundColor: lighten(theme.palette.error.main, 0.8),
      borderColor: lighten(theme.palette.error.main, 0.8),
    },
    "&:focus,&:active": {
      backgroundColor: lighten(theme.palette.error.main, 0.8),
      borderColor: lighten(theme.palette.error.main, 0.8),
    },
    "&:disabled": {
      pointerEvents: "auto",
      color: lighten(theme.palette.primary.main, 0.8),
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
  },
}));

const IconButton: FC<IconButtonProps> = ({ color, className, ...rest }) => {
  const classes: any = useStyles();
  switch (color) {
    case "grey": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.grey)}
          {...rest}
        />
      );
    }
    case "secondary": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.secondary)}
          {...rest}
        />
      );
    }
    case "secondary-dark": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.secondaryDark)}
          {...rest}
        />
      );
    }
    case "success-dark": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.successDark)}
          {...rest}
        />
      );
    }
    case "view":
    case "success": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.success)}
          {...rest}
        />
      );
    }
    case "info": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.info)}
          {...rest}
        />
      );
    }
    case "message": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.message)}
          {...rest}
        />
      );
    }
    case "edit":
    case "warning": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.warning)}
          {...rest}
        />
      );
    }
    case "delete":
    case "error": {
      return (
        <MuiIconButton
          color="default"
          className={clsx(classes.btn, className, classes.error)}
          {...rest}
        />
      );
    }
    default:
      return (
        <MuiIconButton {...rest} className={clsx(className, classes.btn)} />
      );
  }
};

export default React.memo(IconButton);

type CustomColor =
  | "secondary-dark"
  | "grey"
  | "info"
  | "message"
  | "success"
  | "success-dark"
  | "warning"
  | "error"
  | "view"
  | "edit"
  | "delete";
type ButtonColor = CustomColor | PropTypes.Color;

export interface IconButtonProps extends Omit<MuiIconButtonProps, "color"> {
  color?: ButtonColor;
  component?: any;
  to?: any;
  target?: any;
  href?: any;
}
